// Generated by purs version 0.15.15
import * as $foreign from "./foreign.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Error_Class from "../Control.Monad.Error.Class/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Control_Monad_Trans_Class from "../Control.Monad.Trans.Class/index.js";
import * as Data_Argonaut_Decode_Class from "../Data.Argonaut.Decode.Class/index.js";
import * as Data_Argonaut_Decode_Error from "../Data.Argonaut.Decode.Error/index.js";
import * as Data_Argonaut_Encode_Class from "../Data.Argonaut.Encode.Class/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Nullable from "../Data.Nullable/index.js";
import * as Data_TransmissionStats from "../Data.TransmissionStats/index.js";
import * as Data_Undefined_NoProblem_Closed from "../Data.Undefined.NoProblem.Closed/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Fusion_Data_Bytes from "../Fusion.Data.Bytes/index.js";
import * as Fusion_Data_FSError from "../Fusion.Data.FSError/index.js";
import * as Fusion_Data_Json from "../Fusion.Data.Json/index.js";
import * as Fusion_Data_ObservableEvent from "../Fusion.Data.ObservableEvent/index.js";
import * as Fusion_Foreign_Data_NQError from "../Fusion.Foreign.Data.NQError/index.js";
import * as Fusion_Foreign_Rx from "../Fusion.Foreign.Rx/index.js";
import * as Fusion_Generator from "../Fusion.Generator/index.js";
var lift = /* #__PURE__ */ Control_Monad_Trans_Class.lift(Control_Monad_Except_Trans.monadTransExceptT);
var coerce = /* #__PURE__ */ Data_Undefined_NoProblem_Closed.coerce();
var bind = /* #__PURE__ */ Control_Bind.bind(Effect_Aff.bindAff);
var mapFlipped = /* #__PURE__ */ Data_Functor.mapFlipped(Effect_Aff.functorAff);
var liftEffect = /* #__PURE__ */ Effect_Class.liftEffect(Effect_Aff.monadEffectAff);
var mapError = /* #__PURE__ */ Fusion_Foreign_Rx.mapError(Fusion_Foreign_Rx.isObservableLikeObservabl);
var subscribeAff = /* #__PURE__ */ Fusion_Foreign_Rx.subscribeAff(Effect_Aff.monadEffectAff);
var bindExceptT = /* #__PURE__ */ Control_Monad_Except_Trans.bindExceptT(Effect_Aff.monadAff);
var bind1 = /* #__PURE__ */ Control_Bind.bind(bindExceptT);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit)(bindExceptT);
var pure = /* #__PURE__ */ Control_Applicative.pure(/* #__PURE__ */ Control_Monad_Except_Trans.applicativeExceptT(Effect_Aff.monadAff));
var gEncodeJsonCons = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString);
var gEncodeJsonCons1 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_TransmissionStats.encodeJsonTransmissionSta);
var gEncodeJsonCons2 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonArray(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons1(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonArray(Data_TransmissionStats.encodeJsonTransmissionSta))(/* #__PURE__ */ gEncodeJsonCons(/* #__PURE__ */ gEncodeJsonCons(/* #__PURE__ */ gEncodeJsonCons(Data_Argonaut_Encode_Class.gEncodeJsonNil)({
    reflectSymbol: function () {
        return "url";
    }
})())({
    reflectSymbol: function () {
        return "kernelVersion";
    }
})())({
    reflectSymbol: function () {
        return "kernelName";
    }
})())({
    reflectSymbol: function () {
        return "intermediateStats";
    }
})())({
    reflectSymbol: function () {
        return "finalStats";
    }
})())()));
var encodeJson = /* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJson(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeJsonJson))(/* #__PURE__ */ gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons2(/* #__PURE__ */ gEncodeJsonCons1(/* #__PURE__ */ gEncodeJsonCons2(/* #__PURE__ */ gEncodeJsonCons1(Data_Argonaut_Encode_Class.gEncodeJsonNil)({
    reflectSymbol: function () {
        return "passiveFinal";
    }
})())({
    reflectSymbol: function () {
        return "passive";
    }
})())({
    reflectSymbol: function () {
        return "activeFinal";
    }
})())({
    reflectSymbol: function () {
        return "active";
    }
})())())(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJson)(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Fusion_Data_Bytes.encodeJsonBytes)(Data_Argonaut_Encode_Class.gEncodeJsonNil)({
    reflectSymbol: function () {
        return "transferredBytes";
    }
})())({
    reflectSymbol: function () {
        return "transferDuration";
    }
})())({
    reflectSymbol: function () {
        return "tcpStats";
    }
})())({
    reflectSymbol: function () {
        return "speedtestId";
    }
})())({
    reflectSymbol: function () {
        return "intermediateValues";
    }
})())());
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var concatMap = /* #__PURE__ */ Fusion_Foreign_Rx.concatMap(Fusion_Foreign_Rx.isObservableLikeObservabl);
var waitForNext = function (dictMonad) {
    var bind2 = Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(dictMonad));
    var lift1 = lift(dictMonad);
    var pure1 = Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(dictMonad));
    var throwError = Control_Monad_Error_Class.throwError(Control_Monad_Except_Trans.monadThrowExceptT(dictMonad));
    return function (gen) {
        return bind2(lift1(Fusion_Generator.next(gen)))(function (v) {
            if (v instanceof Fusion_Data_ObservableEvent.OnNext) {
                return pure1(v.value0);
            };
            if (v instanceof Fusion_Data_ObservableEvent.OnComplete) {
                return throwError(Fusion_Data_FSError.mk(Fusion_Data_FSError.Cl50.value)("Expected Next"));
            };
            if (v instanceof Fusion_Data_ObservableEvent.OnError) {
                return throwError(v.value0);
            };
            throw new Error("Failed pattern match at Fusion.Foreign.JsSDK (line 383, column 43 - line 388, column 19): " + [ v.constructor.name ]);
        });
    };
};
var waitForNext1 = /* #__PURE__ */ waitForNext(Effect_Aff.monadAff);
var waitForComplete = function (dictMonad) {
    var bind2 = Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(dictMonad));
    var lift1 = lift(dictMonad);
    var pure1 = Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(dictMonad));
    var throwError = Control_Monad_Error_Class.throwError(Control_Monad_Except_Trans.monadThrowExceptT(dictMonad));
    return function (gen) {
        return bind2(lift1(Fusion_Generator.next(gen)))(function (v) {
            if (v instanceof Fusion_Data_ObservableEvent.OnComplete) {
                return pure1(Data_Unit.unit);
            };
            if (v instanceof Fusion_Data_ObservableEvent.OnError) {
                return throwError(v.value0);
            };
            if (v instanceof Fusion_Data_ObservableEvent.OnNext) {
                return throwError(Fusion_Data_FSError.mk(Fusion_Data_FSError.Cl51.value)("Expected Next"));
            };
            throw new Error("Failed pattern match at Fusion.Foreign.JsSDK (line 391, column 47 - line 396, column 57): " + [ v.constructor.name ]);
        });
    };
};
var waitForComplete1 = /* #__PURE__ */ waitForComplete(Effect_Aff.monadAff);
var getLogger = function () {
    return function (options) {
        return function () {
            return $foreign.getLoggerImpl(coerce(options));
        };
    };
};
var fromNQError = function (nqError) {
    var v = Fusion_Foreign_Data_NQError.fromNQError(nqError);
    if (v instanceof Data_Either.Right) {
        return v.value0;
    };
    if (v instanceof Data_Either.Left) {
        return {
            scheme: Fusion_Data_FSError.Cl52.value,
            message: "An error occured while trying to parse NQError to FSError",
            additionalInfo: new Data_Maybe.Just(Data_Argonaut_Decode_Error.printJsonDecodeError(v.value0))
        };
    };
    throw new Error("Failed pattern match at Fusion.Foreign.JsSDK (line 408, column 3 - line 414, column 8): " + [ v.constructor.name ]);
};
var modem = function (sdk) {
    return function (prepareResult) {
        return bind(mapFlipped(liftEffect(function () {
            return $foreign.modemImpl(sdk, prepareResult);
        }))(mapError(fromNQError)))(function (obs) {
            return subscribeAff(obs);
        });
    };
};
var ping = function (sdk) {
    return function (prepareResult) {
        return bind(mapFlipped(liftEffect(function () {
            return $foreign.pingImpl(sdk, prepareResult);
        }))(mapError(fromNQError)))(function (obs) {
            return subscribeAff(obs);
        });
    };
};
var prepare = function (sdk) {
    return function (opts) {
        var optionsImpl = {
            standAloneMode: opts.standAloneMode,
            parentSpeedtestId: Data_Nullable.toNullable(opts.parentSpeedtestId)
        };
        return bind(mapFlipped(liftEffect(function () {
            return $foreign.prepareImpl(sdk, optionsImpl);
        }))(mapError(fromNQError)))(function (v) {
            var mkGen = subscribeAff(v);
            return Effect_Aff.bracket(mkGen)(Fusion_Generator.cancel)(function (gen) {
                return Control_Monad_Except_Trans.runExceptT(bind1(waitForNext1(gen))(function (v1) {
                    return discard(waitForComplete1(gen))(function () {
                        return pure(v1);
                    });
                }));
            });
        });
    };
};
var encodeCalcRequest = function (request) {
    return encodeJson({
        speedtestId: request.speedtestId,
        intermediateValues: map(Fusion_Data_Json.encodeAsBps)(request.intermediateValues),
        transferredBytes: request.transferredBytes,
        transferDuration: Fusion_Data_Json.encodeAsSeconds(request.transferDuration),
        tcpStats: request.tcpStats
    });
};
var defaultPrepareOptions = /* #__PURE__ */ (function () {
    return {
        standAloneMode: false,
        parentSpeedtestId: Data_Maybe.Nothing.value
    };
})();
var decodeObservable = function (dictDecodeJson) {
    var decodeJson = Data_Argonaut_Decode_Class.decodeJson(dictDecodeJson);
    return function (obs) {
        return concatMap(function (json) {
            var v = decodeJson(json);
            if (v instanceof Data_Either.Left) {
                return Fusion_Foreign_Rx.throwError(Fusion_Data_FSError.fromJsonDecodeError(Fusion_Data_FSError.Cl53.value)(json)(v.value0));
            };
            if (v instanceof Data_Either.Right) {
                return Fusion_Foreign_Rx.fromArray([ v.value0 ]);
            };
            throw new Error("Failed pattern match at Fusion.Foreign.JsSDK (line 402, column 7 - line 404, column 38): " + [ v.constructor.name ]);
        })(mapError(fromNQError)(obs));
    };
};
var createNetworkQuality = function () {
    return function (options) {
        return function () {
            return $foreign.createNetworkQualityImpl(options.mode, options.baseURL, options.apiKey, coerce(options.options));
        };
    };
};
var complete = function (sdk) {
    return function (prepareResult) {
        return bind(mapFlipped(liftEffect(function () {
            return $foreign.completeImpl(sdk, prepareResult);
        }))(mapError(fromNQError)))(function (obs) {
            var mkGen = subscribeAff(obs);
            return Effect_Aff.bracket(mkGen)(Fusion_Generator.cancel)(function (gen) {
                return Control_Monad_Except_Trans.runExceptT(bind1(waitForNext1(gen))(function (v1) {
                    return discard(waitForComplete1(gen))(function () {
                        return pure(v1);
                    });
                }));
            });
        });
    };
};
var calcUpload = function (sdk) {
    return function (calcRequest) {
        return bind(mapFlipped(liftEffect(function () {
            return $foreign.calcUploadImpl(sdk, encodeCalcRequest(calcRequest));
        }))(mapError(fromNQError)))(function (obs) {
            var mkGen = subscribeAff(obs);
            return Effect_Aff.bracket(mkGen)(Fusion_Generator.cancel)(function (gen) {
                return Control_Monad_Except_Trans.runExceptT(bind1(waitForNext1(gen))(function (v1) {
                    return discard(waitForComplete1(gen))(function () {
                        return pure(v1);
                    });
                }));
            });
        });
    };
};
var calcDownload = function (sdk) {
    return function (calcRequest) {
        return bind(mapFlipped(liftEffect(function () {
            return $foreign.calcDownloadImpl(sdk, encodeCalcRequest(calcRequest));
        }))(mapError(fromNQError)))(function (obs) {
            var mkGen = subscribeAff(obs);
            return Effect_Aff.bracket(mkGen)(Fusion_Generator.cancel)(function (gen) {
                return Control_Monad_Except_Trans.runExceptT(bind1(waitForNext1(gen))(function (v1) {
                    return discard(waitForComplete1(gen))(function () {
                        return pure(v1);
                    });
                }));
            });
        });
    };
};
var benchmark = function (sdk) {
    return function (prepareResult) {
        return bind(mapFlipped(liftEffect(function () {
            return $foreign.benchmarkImpl(sdk, prepareResult);
        }))(mapError(fromNQError)))(function (obs) {
            return subscribeAff(obs);
        });
    };
};
var abort = function (sdk) {
    return function (prepareResult) {
        return bind(mapFlipped(liftEffect(function () {
            return $foreign.abortImpl(sdk, prepareResult);
        }))(mapError(fromNQError)))(function (v) {
            var mkGen = subscribeAff(v);
            return Effect_Aff.bracket(mkGen)(Fusion_Generator.cancel)(function (gen) {
                return Control_Monad_Except_Trans.runExceptT(waitForComplete1(gen));
            });
        });
    };
};
export {
    loggerLevels,
    measurementModes
} from "./foreign.js";
export {
    abort,
    benchmark,
    calcDownload,
    calcUpload,
    complete,
    createNetworkQuality,
    defaultPrepareOptions,
    getLogger,
    modem,
    ping,
    prepare
};
